module.exports = __webpack_public_path__ + "images/emoji/palm_tree.c0d580169d5330303156.png";